export default __webpack_public_path__ + "static/Swiss721BT-Bold-53f141f327c6eb43516ea65ba34b8b77.ttf";